export const environment = {
  production: true,
   // Activer la duplication des precos vers farmer previs
  enableDuplication: true,
  client_id: '8c481d582cc5472f99dc78980c2cc308',
  JarvisIconUrl:'http://validation-smag-jarvis-icon.smag.local/',

  DownLoad:
  {
    url: 'https://beapi-print-operational.smag.tech/',
    pdfUrl:"https://beapi-print-data-api.smag.tech/Print.asmx",
    download: 'api/farm/DownloadPdf',
  },

  Precizion: {
    url: 'https://beapi-precizionexporter-operational.smag.tech/',
    get_all_console : 'api/console/getall',
    get_user_devices : 'api/console/getUserDevices',
    get_console_download:'api/modulation/datacard/get',
	  get_consoles_send_status:'api/modulation/connected/send/status/get',
    get_user_last_consoles_send_status:'api/modulation/connected/user/lastSend/status',
    get_shape_download :'api/modulation/shape/get',
    file_download :'api/modulation/file/get',
  },
  BeApiOperational: {
    url: 'https://beapi-adviceviewer-operational.smag.tech/',
    getfarms: 'api/farm/CheckFarms',
    getcampagne: 'api/campaign/getcampagnefrombeapi',
    getcultures: 'api/cultivation/getcultivationsfrombeapi',
    getfilter: 'api/farm/GetFarmByCultivationsFiltered',
    getuserinfo:'api/user/getuserinfo',
    getOrdersPrecoFarmerPrevis: 'api/farmerPrevis/GetOrdersPrecoFarmerPrevis',
    saveOrdersPrecoFarmerPrevis: 'api/farmerPrevis/SaveOrdersPrecoFarmerPrevis',
    getRefMinFertilizer: 'api/farmerPrevis/GetReferentialMineralFertilizers',
    getidentities: 'api/smag/identities',
    checksmagaccount: 'api/smag/checksmagaccount',
    refreshSmagToken: 'api/smag/refreshToken',
  },
  SmagAccount: {
    ApplicationId: 'ff0b4ee8-2602-4a71-92d4-8942e2c0b6f0',
    SmagbuttonJs : 'https://identity-account.smag.tech/identity-account-app/prd/account-front.umd.js?',
    SmagbuttonCss : 'https://identity-account.smag.tech/identity-account-app/prd/account-front.css?',
    OcpApimSubscriptionKey: '477091744ced48d495a498adc4550547',
    UrlBuildAuth:  'https://prod-smag-application-api-management.azure-api.net/authentication-operational/v1/api/authentication/build_url',
    smagApiAuthenticationUrl: 'https://prod-smag-application-api-management.azure-api.net/authentication-operational/v1/api/'
  },
  Devices: {
    jsUrl: 'https://smag-precisionag-module.smag.tech/prd/smag-module-precisionag.umd.js',
  },
};
